<a (click)="onOpenCard(data.balance && data.balance < 0 ? null : data.slug)" class="product-card link" *ngIf="data"
   [ngClass]="{'is-disable': data.balance === 0}">
  <div class="product-card__photo" *ngIf="currentSize.buttonImage['src']">
    <picture class="cover-picture">
      <source srcset="{{ currentSize.buttonImage['500x250x100.webp'] }}">
      <img ngSrc="{{ currentSize.buttonImage['src'] }}" loading="auto" [alt]="data.name" alt="" width="200" height="100" appPictureFallback>
    </picture>
  </div>
  <div class="product-card__body">
    <div class="product-card__head">
      <div class="product-card__title h3">
        {{ data.name }}
        <span class="allergen-icon" *ngIf="data.allergens && !!data.allergens.length"><b>A</b></span>
      </div>

      <ng-container *ngIf="currentSize && defaultPrice$ | async as defaultPrice">
        <div class="product-card__price h3">
          <app-price [price]="defaultPrice"></app-price>
        </div>
      </ng-container>
    </div>

    <div class="product-card__caption" *ngIf="data.description">{{ data.description }}</div>

    <ng-container *ngIf="data.itemSizes">
      <div class="product-card__bottom">
        <div class="product-card__portion">
          <ng-container *ngIf="energy">
            {{ energy | number: '1.0-0' }} <span i18n="@@EnergyUnit">kcal</span> |
          </ng-container>
          <ng-container *ngIf="currentSize.portionWeightGrams">
            {{ currentSize.portionWeightGrams | number: '1.0-0' }}

            <ng-container [ngSwitch]="currentSize.measureUnitType">
              <span *ngSwitchCase="'GRAM'" i18n="@@WeightGramUnit">g</span>
              <span *ngSwitchCase="'MILLILITER'" i18n="@@WeightMlUnit">ml</span>
              <span *ngSwitchCase="'KILOGRAM'" i18n="@@WeightKgUnit">kg</span>
              <span *ngSwitchCase="'LITER'" i18n="@@WeightLUnit">l</span>
            </ng-container>
          </ng-container>
        </div>

        <div class="product-card__tags" *ngIf="data.labels && !!data.labels.length">
          <div class="tag-list">
            <div class="tag" *ngFor="let label of data.labels">{{ label.name }}</div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</a>
